import { appUserClient } from 'api';
import { useGetCompanyAndUserInfoQuery } from 'common/queries';
import { Button, FlexRow, ModalFooter } from 'components';
import { FormError, FormWrapper, PasswordInput, SubmitButton } from 'components/forms/hook-form';
import { useCustomTranslation } from 'helpers/translationHelper';
import { useValidators } from 'helpers/validation';
import React from 'react';

interface Props {
  closeForm: () => void;
}

interface PasswordFormValues {
  oldPassword: string;
  newPassword: string;
  newPasswordAgain: string;
}

const AppUserPasswordForm: React.FC<Props> = (props): React.ReactElement => {
  const { closeForm } = props;

  const { t, tInput } = useCustomTranslation();
  const companyAndUserQuery = useGetCompanyAndUserInfoQuery();
  const validators = useValidators();

  const initialValues: PasswordFormValues = {
    newPassword: '',
    newPasswordAgain: '',
    oldPassword: ''
  };

  return (
    <FormWrapper<PasswordFormValues>
      defaultValues={initialValues}
      onSubmit={async (values) => {
        await appUserClient.changePassword(values);
        closeForm();
      }}
    >
      <PasswordInput
        label={t('user.changePassword.oldPasswordLabel')}
        name="oldPassword"
        required
        options={{ required: validators.required }}
      />
      <PasswordInput
        label={t('user.changePassword.newPasswordLabel')}
        name="newPassword"
        required
        options={{ required: validators.required }}
        requireComplexPasswords={companyAndUserQuery.data?.company.requireComplexPasswords}
      />
      <PasswordInput
        label={t('user.changePassword.newPasswordAgainLabel')}
        name="newPasswordAgain"
        required
        options={{
          required: validators.required,
          validate: (value, values) => validators.samePasswordCheck(value, values.newPassword)
        }}
      />
      <FormError />
      <ModalFooter>
        <FlexRow noMargin>
          <Button onClick={closeForm}>{tInput('cancel_button')}</Button>
          <SubmitButton />
        </FlexRow>
      </ModalFooter>
    </FormWrapper>
  );
};

export default AppUserPasswordForm;
